import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Box, IconButton } from '@mui/material';
import { spacing, colors } from 'common/theme';
import { useAddTokenMutation } from 'redux/api/commerce.api';

import { TextHot } from 'components/common/TextHot';
import { ChipHot } from 'components/common/ChipHot';
import { IconHot } from 'components/common/IconHot';
import { generateTestId } from 'app/functions';

import { IframeModalHot } from 'components/common/IframeModalHot';
import { PaymentMethodsList } from '../PaymentMethodsList'; 

import AddIconSvg from 'assets/personal_zone/plus_Outline.svg';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { useTranslations } from 'common/hooks/useTranslations';

const PaymentMethodsDetails = ({ testID, isMobileView }) => {
  const { translate } = useTranslations();
  const history = useHistory();
  const [addToken] = useAddTokenMutation();
  
  const userData = useSelector((store) => store.config.UserData);
  
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [telecardUrl, setTelecardUrl] = useState('');

  const handleCloseAddModal = () => {
    setIsAddModalOpen(false);
    setTelecardUrl('');
  };

  const handleAddClick = async () => {
    setIsAddModalOpen(true);
    setTelecardUrl('');

    try {
      const url = await addToken().unwrap();
      setTelecardUrl(url);
    } catch (e) {
      console.error('Add token failed', e);
      setIsAddModalOpen(false);
    }
  };

  return (
    <Box sx={{ width: '100%', pb: isMobileView ? 12 : 6 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: `${spacing.xs}px` }}>
          {isMobileView && (
            <IconButton onClick={() => history.goBack()} sx={{ p: 0, ml: 1 }}>
              <ChevronRight sx={{ fontSize: spacing.xxxl }} />
            </IconButton>
          )}
          <TextHot size={isMobileView ? 'xxl' : 'xxxl'} bold="bold">
          {translate('personal_zone_payment_methods')}
          </TextHot>
        </Box>

        {!isMobileView && (
          <ChipHot
            testID={generateTestId(testID, 'add-btn-desktop')}
            icon={<IconHot src={AddIconSvg} size={spacing.xl} />}
            label={translate('add_payment_method_content_screen_title')}
            onClick={handleAddClick}
          />
        )}
      </Box>

      <PaymentMethodsList
        testID={generateTestId(testID, 'list')}
        paymentMethods={userData?.cardsArr || []}
        fullName={`${userData?.first_name} ${userData?.last_name}`}
      />

      {isMobileView && (
        <Box
          sx={{
            position: 'fixed',
            bottom: spacing.xxl,
            left: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'center',
            zIndex: 10,
            pointerEvents: 'none'
          }}
        >
          <Box sx={{ pointerEvents: 'auto' }}>
            <ChipHot
              testID={generateTestId(testID, 'add-btn-mobile')}
              icon={<IconHot src={AddIconSvg} size={spacing.xl} />}
              label={translate('add_payment_method_content_screen_title')}
              onClick={handleAddClick}
              sx={{
                boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.15)',
                backgroundColor: colors.palette.white,
                border: `1px solid ${colors.palette.blueAlpha200}`
              }}
            />
          </Box>
        </Box>
      )}

      <IframeModalHot
        testID={generateTestId(testID, 'add-modal')}
        open={isAddModalOpen}
        onClose={handleCloseAddModal}
        src={telecardUrl}
      />
    </Box>
  );
};

export default PaymentMethodsDetails;